import { PlayTextStyles } from 'app/ui-components/typography/PlayText/PlayText.styles';
import styled from 'styled-components';
import { device } from '../../../ui-components/breakpoints';
import { iconArrowLeft, playTransitionEasing, regularWhite } from '../../../ui-components/design-tokens';
import { playFontIcon } from '../../../ui-components/typography/helpers';
import { playFocus } from '../../../ui-components/utils.styles';

export const StyledBackButtonText = styled.span`
    ${PlayTextStyles}
    display: none;
    vertical-align: middle;
    margin-left: 5px;

    @media ${device.GteSmall} {
        display: inline;
    }
`;

export const StyledBackButton = styled.button`
    pointer-events: all;
    display: block;
    color: ${regularWhite};
    cursor: pointer;
    text-decoration: none;
    line-height: 1;
    background: none;
    border: none;
    outline: none;
    text-transform: uppercase;
    padding-left: 0;
    padding-right: 15px;
    ${playFocus()}

    &:before {
        ${playFontIcon(2, iconArrowLeft)}
        text-decoration: none;
        transition: transform 200ms ${playTransitionEasing};
    }

    &:hover:before {
        transform: translateX(-4px);
    }

    &:hover {
        ${StyledBackButtonText} {
            text-decoration: underline solid ${regularWhite} 1px;
            text-underline-position: under;
        }
    }
`;
